"use client";

import { DotMatrix } from "@/app/components/dot-matrix";
import { useActionState } from "react";
import { subscribeToWaitlist } from "../actions/subscription";
import { Button } from "@/components/ui/button";

export default function Waitlist() {
  const [state, formAction, isPending] = useActionState(
    subscribeToWaitlist,
    null,
  );
  const isSubmitted = state?.success;

  return (
    <main className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden py-12 px-4">
      <DotMatrix
        variant="diamond"
        pixelSize={3}
        patternScale={1}
        enableRipples={true}
        rippleIntensityScale={1.5}
        rippleSpeed={0.4}
        speed={1.5}
        edgeFade={0.15}
      />

      <div className="max-w-2xl w-full text-center space-y-12 animate-in fade-in duration-700">
        <div className="space-y-6">
          <h1 className="font-sans text-5xl md:text-6xl italic tracking-tight text-balance leading-[1.1]">
            Join Our Waitlist
          </h1>

          <p className="text-base md:text-lg text-muted-foreground max-w-xl mx-auto text-balance leading-relaxed">
            Join the waitlist and be the first to know when we launch.
          </p>
        </div>

        <div className="w-full flex justify-center">
          <div className="relative w-100">
            <div className="absolute inset-0 animate-in fade-in duration-500 clerk-waitlist-clean">
              <form action={formAction} className="mb-24 w-full">
                {/* Using concentric border radius (padding is 4px, outer is 24px, inner is 20px) and shadows instead of borders */}
                <div className="relative flex items-center gap-1 rounded-[14px] bg-white p-1 transition-shadow duration-300 ease-out focus-within:shadow-[0px_0px_0px_1px_rgba(59,130,246,0.5),0px_2px_8px_-2px_rgba(59,130,246,0.15),0px_4px_16px_0px_rgba(59,130,246,0.1)] hover:shadow-[0px_0px_0px_1px_rgba(0,0,0,0.08),0px_1px_2px_-1px_rgba(0,0,0,0.08),0px_2px_4px_0px_rgba(0,0,0,0.06)] shadow-[0px_0px_0px_1px_rgba(0,0,0,0.06),0px_1px_2px_-1px_rgba(0,0,0,0.06),0px_2px_4px_0px_rgba(0,0,0,0.04)]">
                  <label className="sr-only" htmlFor="waitlist-email">
                    Email address
                  </label>
                  <input
                    id="waitlist-email"
                    name="email"
                    type="email"
                    placeholder="Email"
                    required
                    disabled={isPending || isSubmitted}
                    className="min-h-9 flex-1 min-w-0 bg-transparent pl-3 sm:pl-4 pr-2 sm:pr-3 text-sm sm:text-[15px] tabular-nums text-stone-900 placeholder:text-stone-400 outline-none disabled:opacity-50"
                  />

                  <Button
                    type="submit"
                    disabled={isPending || isSubmitted}
                    className="cursor-pointer group relative inline-flex h-9 items-center justify-center rounded-[10px] bg-blue-400 px-3 sm:px-6 text-xs sm:text-[15px] font-medium text-white whitespace-nowrap transition-[transform,background-color,box-shadow] duration-200 ease-out hover:bg-blue-500 active:scale-95 shadow-[0px_1px_2px_rgba(0,0,0,0.1),inset_0px_1px_1px_rgba(255,255,255,0.2)] disabled:pointer-events-none disabled:opacity-80"
                  >
                    <span
                      className={`text-nowrap transition-[opacity,transform,filter] duration-300 ease-[cubic-bezier(0.2,0,0,1)] ${isSubmitted || isPending ? "scale-[0.8] blur-[4px] opacity-0" : "scale-100 blur-0 opacity-100"}`}
                    >
                      Notify me
                    </span>
                    <span
                      className={`absolute flex items-center justify-center transition-[opacity,transform,filter] duration-300 ease-[cubic-bezier(0.2,0,0,1)] ${isSubmitted ? "scale-100 blur-0 opacity-100" : "scale-[0.8] blur-[4px] opacity-0"}`}
                    >
                      ✓
                    </span>
                    <span
                      className={`absolute flex items-center justify-center transition-[opacity,transform,filter] duration-300 ease-[cubic-bezier(0.2,0,0,1)] ${isPending && !isSubmitted ? "scale-100 blur-0 opacity-100" : "scale-[0.8] blur-[4px] opacity-0"}`}
                    >
                      <div className="h-4 w-4 animate-spin rounded-full border-2 border-white/20 border-t-white" />
                    </span>
                  </Button>
                </div>
                {state?.error && (
                  <p className="mt-3 text-center text-[13px] text-red-500">
                    {state.error}
                  </p>
                )}
              </form>
              <div className="flex flex-col items-center gap-4 text-[14px] text-stone-500">
                <p className="text-[#252525]">handcrafted in Algiers.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
